import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/404.svg")